import { useContext, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { RootStoreContext } from '../App';
import * as Cookie from '../utils/Cookie';

const useSessionWatcher = () => {
	const { authStore } = useContext(RootStoreContext);
	const navigate = useNavigate();
	const isLoggingOut = useRef(false);

	useEffect(() => {
		let timeoutId;

		const checkSessionExpiry = () => {
			clearTimeout(timeoutId);
			if (isLoggingOut.current) return;

			const token = Cookie.get('token');
			const expiresAt = Number(Cookie.get('expiresAt'));
			const remainingTime = expiresAt - Date.now();

			if (!token || !Number.isFinite(expiresAt) || remainingTime <= 0) {
				isLoggingOut.current = true;
				authStore.logout();
				navigate('/login', { replace: true });
				alert('로그인 시간이 만료되었습니다.\n다시 로그인해 주시기 바랍니다.');
				return;
			}

			// 화면을 계속 사용하는 동안에도 만료 시각에 다시 확인합니다.
			timeoutId = setTimeout(
				checkSessionExpiry,
				Math.min(remainingTime, 2147483647),
			);
		};

		const handleVisibilityChange = () => {
			if (document.visibilityState === 'visible') checkSessionExpiry();
		};

		window.addEventListener('focus', checkSessionExpiry);
		document.addEventListener('visibilitychange', handleVisibilityChange);
		checkSessionExpiry();

		return () => {
			clearTimeout(timeoutId);
			window.removeEventListener('focus', checkSessionExpiry);
			document.removeEventListener('visibilitychange', handleVisibilityChange);
		};
	}, [authStore, navigate]);
};

export default useSessionWatcher;
